import React from "react";

const Button = ({
  label,
  onClick,
  containerStyle,
  type,
  loading,
  disabled
}) => {
  return (
    <button
      type={type ?? "button"}
      onClick={onClick}
      disabled={disabled}
      className={`p-2 text-white bg-green-800 flex items-center justify-center rounded cursor-pointer ${containerStyle}`}
    >
      {loading ? "Loading..." : label}
    </button>
  );
};

export default Button;
